module.exports = __webpack_public_path__ + "static/media/black-identify-multiple-features-icon.d72b3ac8.svg";